<template>
  <v-container fluid>
    <validation-observer ref="observer" v-slot="{ handleSubmit }">
      <v-form @submit.prevent="handleSubmit(salvar)">
        <v-row>
          <v-col cols="12">
            <base-material-card color="primary" icon="mdi-shield-lock" inline class="px-5 py-3" :title="titulo">
              <v-row class="mt-5">
                <v-col cols="12">
                  <validation-provider
                    v-slot="{ errors }"
                    name="IP"
                    :rules="{ required: true, regex: /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/ }"
                  >
                    <v-text-field
                      id="ip-acesso-ip"
                      v-model="formulario.ip"
                      label="IP"
                      outlined
                      placeholder="0.0.0.0"
                      :error-messages="errors"
                    />
                  </validation-provider>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-alert id="ip-acesso-portas-info" dense text type="info" icon="mdi-lock-check-outline">
                    O acesso será liberado automaticamente nas portas 5432 (PostgreSQL padrão) e 54323 (legada Geon).
                  </v-alert>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <validation-provider
                    v-slot="{ errors }"
                    name="Descrição"
                    :rules="{ required: true, max: 60, regex: /^[A-Za-z0-9 ]+$/ }"
                  >
                    <v-text-field
                      id="ip-acesso-descricao"
                      v-model="formulario.descricao"
                      label="Descrição"
                      outlined
                      hint="Sem acentos ou caracteres especiais, máximo 60 caracteres"
                      :error-messages="errors"
                    />
                  </validation-provider>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <validation-provider v-slot="{ errors }" name="Security Group" :rules="{ required: true }">
                    <v-select
                      id="ip-acesso-security-group"
                      v-model="formulario.security_group_nome"
                      :items="securityGroupsDisponiveis"
                      label="Security Group"
                      outlined
                      :error-messages="errors"
                    />
                  </validation-provider>
                </v-col>
              </v-row>
            </base-material-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-btn id="btn-cancelar-ip-acesso" text style="float: right" class="mr-2" @click="cancelar">Cancelar</v-btn>
            <v-btn
              id="btn-salvar-ip-acesso"
              color="primary"
              min-width="100"
              style="float: right"
              class="mr-2"
              type="submit"
              :loading="salvando"
            >
              Salvar
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </validation-observer>
  </v-container>
</template>

<script>
  import axios from 'axios';
  import IpsAcessoBancoDadosAwsService from '@/services/aws/IpsAcessoBancoDadosAwsService';
  import routes from '@/store/modules/routes';

  const formularioInicial = () => ({
    id: null,
    ip: '',
    descricao: '',
    security_group_nome: null
  });

  export default {
    name: 'IpAcessoBancoDadosEdit',

    data: () => ({
      loading: false,
      salvando: false,
      securityGroupsDisponiveis: [],
      formulario: formularioInicial()
    }),

    computed: {
      ipAcessoId() {
        return this.$route.params.id;
      },
      addMode() {
        return this.ipAcessoId === undefined;
      },
      titulo() {
        return this.addMode ? 'Novo IP de Acesso' : 'Editar IP de Acesso';
      }
    },

    mounted() {
      this.getSecurityGroupsDisponiveis();

      if (this.ipAcessoId) {
        this.getIpAcesso(this.ipAcessoId);
      } else {
        this.preencherMeuIp();
      }
    },

    methods: {
      preencherMeuIp() {
        // Serviço externo, pois é o IP que o navegador usa para acessar a internet
        // (o mesmo usado para conectar direto ao PostgreSQL) que precisa ser liberado.
        axios
          .get('https://api.ipify.org?format=json')
          .then(({ data }) => {
            this.formulario.ip = data.ip;
          })
          .catch((error) => {
            console.error(error);
          });
      },
      getSecurityGroupsDisponiveis() {
        IpsAcessoBancoDadosAwsService.listarSecurityGroupsDisponiveis()
          .then(({ data }) => {
            this.securityGroupsDisponiveis = data;
          })
          .catch((error) => {
            console.error(error);
            this.$toast.error('Erro ao recuperar os security groups disponíveis.', '', { position: 'topRight' });
          });
      },
      getIpAcesso(id) {
        this.loading = true;
        IpsAcessoBancoDadosAwsService.buscar(id)
          .then(({ data }) => {
            this.formulario = { ...formularioInicial(), ...data.data };
          })
          .catch((error) => {
            console.error(error);
            this.$toast.error('Erro ao recuperar o IP de acesso.', '', { position: 'topRight' });
            this.voltar();
          })
          .finally(() => (this.loading = false));
      },
      salvar() {
        this.salvando = true;
        IpsAcessoBancoDadosAwsService.salvar(this.formulario)
          .then(() => {
            this.$toast.success('IP de acesso salvo com sucesso.', '', { position: 'topRight' });
            this.voltar();
          })
          .catch((error) => {
            console.error(error);
            this.$toast.error('Erro ao salvar o IP de acesso.', '', { position: 'topRight' });
          })
          .finally(() => (this.salvando = false));
      },
      cancelar() {
        this.voltar();
      },
      voltar() {
        this.$router.push({
          name: routes.state.appRoutes['VIZUALIZAR_PERFIL'],
          query: { tab: 'tab-ips-acesso' }
        });
      }
    }
  };
</script>

<style scoped></style>
